module.exports = __webpack_public_path__ + "img/coming_soon.5d13eb0e.png";